import { AddCircleOutlineOutlined } from '@mui/icons-material';
import React from "react";
import styled from "styled-components";

const AddMoreCell = ({ handleAddCell, selectedType }) => {
  return (
    <Cell onClick={handleAddCell} className="word-cell" selectedType={selectedType}>
      <AddCircleOutlineOutlined />
    </Cell>
  );
};

export default AddMoreCell;

const Cell = styled.div`
  width: 100%;
  height: ${(props) => (props.selectedType === "Image" || props.selectedType === "VocabImage" ||  props.selectedType === "OnlyImage" ? "auto" : "150px")};
  min-height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  background-color: ${(props) => props.backgroundColor || "#333"};
  flex-direction: ${(props) =>
    props.selectedType === "Image" ? "column" : "row"};
  gap: ${(props) => (props.selectedType === "Image" ? "10px" : "0")};
  color: #fff;
  padding: ${(props) => (props.selectedType === "Image" ? "10px" : "0")};
  border: 3px dashed #080808;
`;
